import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination
} from '@material-ui/core';

/*import { getInitials } from 'helpers';*/
import Datetime from 'components/DataTypes/Datetime';
import TableToolbar from './TableToolbar';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  date: {
    width: "15rem"
  },
  notAvailable: {
    color: "rgba(0,0,0,0.4)",
    fontStyle: "italic"
  },
  headerElement: {
    whiteSpace: "nowrap"
  },
  numberElement: {
    textAlign: "right"
  }
}));

const DGPTable = props => {
  const { className, loadingDgps, dgps, total, page, rowsPerPage, onChangePage, onFilter, ...rest } = props;

  const classes = useStyles();


  const handlePageChange = (event, page) => {
    onChangePage(page);
  };

  const handleRowsPerPageChange = event => {
    //setRowsPerPage(event.target.value);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <TableToolbar onFilter={onFilter} />
            <Table>
              <colgroup>
                <col />
                <col className={classes.date} />
              </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerElement}>Name</TableCell>
                  <TableCell className={classes.headerElement}>Created at</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={loadingDgps ? "loading" : ""}>
                {dgps.slice(0, rowsPerPage).map(queue => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={'queue_' + queue.uuid}
                  >
                    <TableCell>
                      <Link to={`/dgps/${queue.uuid}`}>{queue.label}</Link>
                    </TableCell>
                    <TableCell>
                      <Datetime value={queue.created_at} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={total}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[50]}
          showFirstButton={true}
          showLastButton={true}
        />
      </CardActions>
    </Card>
  );
};

DGPTable.propTypes = {
  className: PropTypes.string,
  dgps: PropTypes.array.isRequired
};

export default DGPTable;
